import React from 'react';
import { PreviewPanePodcast } from '../../../types';

export type AddPodcastModalContextType = {
  previewPanePodcast: PreviewPanePodcast | null;
  setPreviewPanePodcast(rssFeed: PreviewPanePodcast | null): void;
  nextButtonDisabled: boolean;
  setNextButtonDisabled(disabled: boolean): void;
};

export const AddPodcastModalContext = React.createContext<AddPodcastModalContextType>({
  previewPanePodcast: null,
  setPreviewPanePodcast(rssFeed: PreviewPanePodcast) {},
  nextButtonDisabled: false,
  setNextButtonDisabled(disabled: boolean) {},
});
